import React, { memo } from 'react'
import RoadSvg from '../../svgs/Road'
import CityRoadTransition from '../../hocs/CityRoadTransition'

const Road = memo(props => {
  return <RoadSvg {...props} />
})
export default CityRoadTransition(Road)
